module.exports = {"edit":"Provider Chain ändern","type":"Typ der Provider Chain","spec":"Provider Chain","resetHint":"Icon anklicken zum Zurücksetzen"}